export const FacebookUrl = 'https://www.facebook.com/Itransition';
export const TwitterUrl = 'https://twitter.com/itransition';
export const LinkedinUrl = 'https://www.linkedin.com/company/itransition';
export const InstagramUrl = 'https://www.instagram.com/itransition_team/';
export const ItransitionBy = 'https://itransition.by/';
export const ItransitionEU = 'https://itransition.eu/';
export const ItransitionRecruitmentEmail = 'hh@itransition.com';
export const ItransitionInfoEmail = 'info@itransition.com';
export const ClutchWidgetUrl = 'https://widget.clutch.co/widgets/get/1?uid=21074';
